import { isEmpty } from 'lodash-es'
import type { HTMLAttributes } from 'react'
import Comment, { type CommentData, type CommentProps } from './Comment'
import CommentListContent from './CommentListContent'

export interface CommentListProps extends HTMLAttributes<HTMLDivElement> {
	data: CommentData[]
	isLoading?: boolean
	noActions?: CommentProps['noActions']
	noReplies?: CommentProps['noReplies']
}

export default function CommentList({
	data,
	isLoading = false,
	noActions,
	noReplies,
	...props
}: CommentListProps) {
	return (
		<CommentListContent empty={isEmpty(data)} isLoading={isLoading} {...props}>
			{data.map((item) => (
				<Comment data={item} key={item.id} noActions={noActions} noReplies={noReplies} />
			))}
		</CommentListContent>
	)
}
